import React from 'react';
import ReactDOM from 'react-dom/client';

// remove this if you have no index.css
import './index.css';

import App from './App.jsx';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { registerBaseServiceWorker } from './notifications';

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

registerBaseServiceWorker();
